import { CustomerModel } from "../../../factories/customers/models/customerModel";

/**
 * The Contacts list "Display name" column, same rule as the client profiles:
 * organizations show their display name (DBA); individuals their display
 * name, or else their first + last name. "-" when there is nothing.
 */
export const listDisplayName = (
  row: Pick<
    CustomerModel,
    "businessContactId" | "dba" | "displayName" | "firstName" | "lastName"
  >,
): string => {
  if (row.businessContactId) return row.dba?.trim() || "-";
  const fullName = `${row.firstName || ""} ${row.lastName || ""}`
    .replace(/\s+/g, " ")
    .trim();
  return row.displayName?.trim() || fullName || "-";
};

/** "1 Contact" / "5 Contacts" (the list heading). */
export const contactsCountLabel = (count: number) =>
  `${count} ${count === 1 ? "Contact" : "Contacts"}`;
